// Cross-platform confirmation dialog backed by a React component.
// Falls back to native window.confirm if the component isn't mounted.

let _listener = null;

export const confirmAction = (message, options = {}) =>
  new Promise((resolve) => {
    if (_listener) {
      _listener({
        message,
        confirmLabel: options.confirmLabel || "Confirmar",
        cancelLabel: options.cancelLabel || "Cancelar",
        destructive: options.destructive !== false,
        resolve,
      });
    } else {
      // Fallback for SSR or if dialog not mounted
      // eslint-disable-next-line no-alert
      resolve(typeof window !== "undefined" ? window.confirm(message) : false);
    }
  });

export const setConfirmListener = (fn) => {
  _listener = fn;
};
